import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import isEqual from 'lodash.isequal';
export function useObjectMemo(value) {
  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      memoizedValue = _useState2[0],
      setMemoizedValue = _useState2[1];

  useEffect(function () {
    if (!isEqual(value, memoizedValue)) setMemoizedValue(value);
  }, [value]);
  return memoizedValue;
}